//save as site: {
// 1day:{}
//1hour:{}
// }
//event driven development
import { useEffect } from 'react';

import { FirebaseService } from '@flexo/general';

import { useDispatch, useSelector } from 'react-redux';
import { KPI, USER, ALERT } from '@flexo/reducers';
import { useLocation, useParams } from 'react-router-dom';

const ENV = (import.meta as any).env;

const firebaseService = new FirebaseService();

export const EconomicsCustomKpiSiteResolver = () => {

  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();

  const pathSegment = location.pathname.split('/')[1]; 
  const metadata = useSelector((state: any) => state.metadata);
  const calendar = useSelector((state: any) => state.calendar);

  const { hiveCalendar } = calendar;
  const { selectedDate, selectedTimeSet } = hiveCalendar;

  async function init() {

    // if (!pathSegment?.includes('site') && !pathSegment?.includes('household')) { return; }

    const idToken = await firebaseService.getIdToken();
    const SITE_ID = params?.id || metadata?.entities?.site?.[0]?.siteId;

    if (!idToken) {
      dispatch(ALERT.SetAlert({
        value: {
          type: 'BANNER_SESSION_EXPIRED',
        },
      } as any));

      // setUserStore({
      //   type: UserTypes.SetUserLogOut,
      //   payload: {
      //     value: true,
      //   },
      // });

      dispatch(USER.SetLogout());

      return;
    }

    if (!SITE_ID) { return; }

    dispatch(KPI.SetEconomicsCustomKpiDataSiteAsync({ SITE_ID, idToken, selectedDate, selectedTimeSet }) as any);

  }

  useEffect(() => {
      init();
  }, []);

  useEffect(() => {
      init();
  }, [selectedDate, metadata?.entities, params?.id, pathSegment]);

  return <></>;
};
